/* eslint-disable @typescript-eslint/no-explicit-any */
import Field from '@/gf/components/next/forms/Field'
import { Control, Controller, DeepPartialSkipArrayKey, UseFormReturn } from 'react-hook-form'
import { PlusIcon } from '@heroicons/react/20/solid'
import Action from '@/gf/components/Action'
import { FormValues, Part } from '../PartDetailsStep'
import CostCodeSelector from '@/buyers/components/CostCodeSelector'

const CostCodeForm = ({
  control,
  partIndex,
  errors,
  part,
  getDefaultCostCode,
}: {
  control: Control<FormValues, any>
  partIndex: number
  errors: NonNullable<UseFormReturn<FormValues, any>['formState']['errors']['parts']>[number]
  part: DeepPartialSkipArrayKey<Part>
  getDefaultCostCode?: () => { id: string } | null
}) => {
  return part.costCode ? (
    <div className="flex gap-x-4">
      <Field
        label="Cost Code"
        error={errors?.costCode?.id?.message}
        htmlFor={`costCode`}
        className="flex-grow"
      >
        <Controller
          control={control}
          name={`parts.${partIndex}.costCode.id`}
          render={({ field }) => (
            <CostCodeSelector autoFocus value={field.value} onChange={field.onChange} />
          )}
        />
      </Field>

      <Controller
        control={control}
        name={`parts.${partIndex}.costCode`}
        render={({ field }) => (
          <Action.T className="mt-[26px] h-8 text-sm" onClick={() => field.onChange(null)}>
            Remove
          </Action.T>
        )}
      />
    </div>
  ) : (
    <Controller
      control={control}
      name={`parts.${partIndex}.costCode`}
      render={({ field }) => (
        <Action.S
          onClick={() => field.onChange(getDefaultCostCode?.() ?? { id: null })}
          size="sm"
          className="flex gap-x-1 items-center"
        >
          <PlusIcon className="h-4 w-4 text-gray-900 inline-block" /> Add Cost Code
        </Action.S>
      )}
    />
  )
}

export default CostCodeForm
